import { useConfig } from '@browsing/config';
import { getCookie } from '@pegasus/utils';
import {
    FREE_DELIVERY_BANNER_COOKIE,
    FREE_DELIVERY_COOKIE,
} from '@client/components/mylounge/constants';
import { useLoyalty } from '@client/components/mylounge/hooks/use-loyalty';
import { LoyaltyStatus } from '@pegasus/plus';

import { useMemo } from 'react';

const localizedMonth = (locale: string, month: number) => {
    const formatter = new Intl.DateTimeFormat(locale, { month: 'long' }).format;
    return formatter(new Date(Date.UTC(2021, month - 1)));
};

const UNLIMITED_FREE_DELIVERY_MONTH = 4;
const UNLIMITED_FREE_DELIVERY_TEST_COOKIE = 'zl_force_unlimited_free_delivery';

export const useUnlimitedFreeDelivery = () => {
    const config = useConfig();
    const languageCode = config.localeCode.replace('_', '-');
    const loyalty = useLoyalty();
    const isLoyaltyMember = loyalty?.summary?.status === LoyaltyStatus.Active;
    const hasFreeDeliveryBenefit = useMemo(() => {
        return loyalty?.summary?.benefits?.some(benefit => benefit.name === 'FREE_DELIVERY');
    }, [loyalty?.summary?.status]);

    const minimumOrderValue = useMemo(() => {
        const isFreeDelivery = loyalty?.summary?.benefits?.filter(benefit => {
            return benefit.name === 'FREE_DELIVERY';
        });

        if (isFreeDelivery?.length > 0) {
            return isFreeDelivery[0].minimumOrderValue;
        }
    }, [loyalty?.summary?.status]);

    const isActive =
        config.isEnabled('loyalty_free_delivery_unlimited_communication_enabled') ||
        getCookie(UNLIMITED_FREE_DELIVERY_TEST_COOKIE) === 'true';
    const isModalDismissed = getCookie(FREE_DELIVERY_COOKIE) === 'true';
    const isBannerDismissed = getCookie(FREE_DELIVERY_BANNER_COOKIE) === 'true';
    return {
        isActive,
        showBanner:
            isActive &&
            isModalDismissed &&
            isLoyaltyMember &&
            hasFreeDeliveryBenefit &&
            !isBannerDismissed,
        month: localizedMonth(languageCode, UNLIMITED_FREE_DELIVERY_MONTH),
        minimumOrderValue,
    };
};
